<template>
  <div>
    <div id="banner" style="float:left;">
      <el-carousel :interval="80000" arrow="none" :height="500" class="banner-top">
        <el-carousel-item v-for="item in img_list" :key="item">
          <el-image :src="item" fit="cover" style="height:100%;width:100%"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
	<div style="height:500px;">
	</div>
	<div>
		<h2 class="index_h2 hidden-xs">山港保经</h2>
		<h4 class="index_h4 hidden-xs">ABOUT US</h4>
	</div>
	<div class="container fluid">
		<div class="col-sm-6 intro">
			<a href="/#/SinglePage?name=1&id=6506&type=6502" class="intro_icon profile" style="padding-top:10px;height:40px;">
				公司简介<span>Profile</span>
			</a>
			<p v-if="compIntroHome[0]">{{compIntroHome[0].description}}</p>
			<a href="/#/SinglePage?name=1&id=6506&type=6502" class="intro_link hidden-xs"></a>
		</div>
		<div class="col-sm-6 intro">
			<a href="/#/SinglePage?name=1&id=6512&type=6502" class="intro_icon history" style="padding-top:10px;height:40px;">
				发展历史<span>History</span>
			</a>
			<p v-if="compHistHome[0]">{{compHistHome[0].description}}</p>
			<a href="/#/SinglePage?name=1&id=6512&type=6502" class="intro_link hidden-xs"></a>
		</div>
	</div>

	<h2 class="index_h2 hidden-xs" style="margin-top:0px;">服务对象</h2>
	<h4 class="index_h4 hidden-xs">CUSTOMERS</h4>
	<div class="bankuai_produce hidden-xs" style="margin-top:1.5em;">
		<div class="produce select">
			<div class="bankuai select">
				<div v-for="coopItem in coopListHome.slice(0,10)" class="content1" id="home_ywbk_0">
					<a :href="'/#/SinglePage?name=1&id=6533&type=6503&cid='+coopItem.cid">
					<p :class="coopItem.pic" style="margin:0;"></p>
					<p style="margin-bottom:0;">{{coopItem.title}}</p>
					</a>
				</div>
			</div>
		</div>
	</div>
  <h2 class="index_h2 hidden-xs">友情链接</h2>
  <h4 class="index_h4 hidden-xs">LINKS</h4>
  <el-row :gutter="40" class="home-center-box" style="padding-bottom: 30px;margin-top:1.5em;">
      <el-col :span="12" :offset="6" class="home-center home-center-news bottom-like" :xs="{span: 21, offset: 1}">
        <el-tabs v-model="activeName" @tab-click="handleClick" stretch>
          <el-tab-pane label="监管部门" name="supervise">
            <div class="links-ul">
              <div class="links-li" v-for="value in friendLinkList" v-if="value.type==1" >
                <a :href="value.link"  v-if="value.name" target="_blank" >
                  <span style="font-size:large;">{{ value.name }}</span>
                </a>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="港内单位" name="transaction">
            <div class="links-ul">
              <div class="links-li" v-for="value in friendLinkList" v-if="value.type==2">
                <a :href="value.link"  v-if="value.name" target="_blank" >
                  <span style="font-size:large;">{{ value.name }}</span>
                </a>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="合作企业" name="cooperation">
            <div class="links-ul">
              <div class="links-li" v-for="value in friendLinkList" v-if="value.type==3">
                <a :href="value.link"  v-if="value.name" target="_blank" >
                  <span style="font-size:large;">{{ value.name }}</span>
                </a>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "Home",
	components:{

      },
    data() {
      return {
        activeName: 'supervise',
        mWidth: 765,
        screenWidth: document.body.clientWidth,
        bannerHeight:'',
        friendLinkList:[],
		compIntroHome:[],
		compHistHome:[],
		coopListHome:[],
		img_list:[],
		mobileMode:false,
      };
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
      },
      routerTo(value){
        this.$router.push(value)
      },
	},
	computed:{
    },
    watch: {
      screenWidth (val) {
        this.screenWidth = val
        this.bannerHeight = (val * 200) / this.mWidth+ "px";
      },
      immediate: true, //immediate为true才会监听第一次绑定
    },
    mounted () {
      const that = this;
      window.onresize = function() {
        return function(){
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth
         }()
      }
    },
    created() {
      this.mobileMode = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      if(this.mobileMode){this.mWidth=400;
      } else { this.mWidth=765 };
      this.bannerHeight = (this.screenWidth * 200) / this.mWidth+ "px";
      //banner
      this.$getAjax(this.$bannerList,{},(res)=>{
       for(let i in res.result){
         //this.img_list.push(this.$baseURL+'/'+res.result[i].banner);
         this.img_list.push(res.result[i].banner);
       }
      });

      // 友情链接
      this.$getAjax(this.$linkList,{},(res)=>{
          this.friendLinkList=res.result;
      });

	  this.$getAjax(this.$compIntroHome,{},(res)=>{
          this.compIntroHome=res.rows;
      });
	  this.$getAjax(this.$compHistHome,{},(res)=>{
          this.compHistHome=res.rows;
      });
	  this.$getAjax(this.$coopListHome,{},(res)=>{
	      var tempList;
          tempList = res.rows;
		  for(var i = tempList.length-1; i >=0 ; i--) {
		      this.coopListHome.push(tempList[i]);
		  }
      });
    },

	beforeDestroy() {
	}

  }
</script>

<style scoped>
  #news-marquee {
      background: #f3f3f3;
  }
  .marquee-sibling {
    padding: 0;
    background: #f3f3f3;
    width: 120px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    font-weight: normal;
    color: #BF925F;
    text-align: center;
    left: 0;
    z-index: 1;
  }
  .companyNew-ul{
    background: #fff;
    padding: 15px 0 15px 0;
    min-height: 189px;
  }
  .companyNews-img{
    float: left;
    margin-top: 10px;
    width: 100%;
    height: 137px;
    object-fit: cover;
  }
  #banner {
    width: 100%;
  }

  .links-li {
    text-align: center;
    line-height: 35px;
    float: left;
    margin: 0 10px;
  }
  a {
    color: #272727;
  }
</style>




// WEBPACK FOOTER //
// src/views/Home.vue